import { render, staticRenderFns } from "./NewPanelPopup.vue?vue&type=template&id=36b3b7a0&"
import script from "./NewPanelPopup.vue?vue&type=script&lang=ts&"
export * from "./NewPanelPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports